import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Layout, List, Avatar, Menu, Dropdown, Space, Badge } from "antd";

import { UserOutlined, BellOutlined, ReadFilled} from "@ant-design/icons";
import { logout } from "@/redux/auth/actions";
import uniqueId from "@/utils/uinqueId";

import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "@/config/serverApiConfig";
const { Header } = Layout;

export default function HeaderContent() {
  const dispatch = useDispatch();

 let [list, setList] = useState([{
    id: uniqueId(),
    content: "",
 }]);


  let [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {

    // create api that get token from localStorage and send it to server to get user info if the token is not valid or expired logout user
    const tokenWithoutQuotes = localStorage.getItem("x-auth-token");
    // remove "" from token
    const token = tokenWithoutQuotes.replace(/"/g, "");
    // get user info from server

    if (token) {
      axios
        .get(`${API_BASE_URL}checkLogin`, {
          headers: {
            Authorization: token,
          },
        })
        
        .then((res) => {
          console.log(res);
          // remove x-auth-token from localStorage if res.data.success is false and logout user
          if (res.data.success == false) {
            console.log(res.data);
            
            console.log("logout user from device because token is not valid or expired");
            localStorage.removeItem("x-auth-token");
            dispatch(logout());
          }
        }
      )
        .catch((err) => {
          console.log(err);
        }
      );
    }

  
    axios.get(`${API_BASE_URL}admin/notificationsCount`).then
    (res => {
      setNotificationCount(res.data.result);
      

      
    }
    )
  }, []);

  useEffect(() => {

  
    axios.get(`${API_BASE_URL}admin/notifications`).then
    (res => {
      setList(res.data.result);
      
    }
    )
  }, []);

const menu = (
  <Menu>
    <Menu.Item key={uniqueId()} onClick={() => dispatch(logout())}>
        logout
      </Menu.Item>
     
      <Menu.Item key={uniqueId()}>
        <Link to="/admin/admin-panel/change-password">Change Password</Link>
      </Menu.Item> 
  </Menu>
);

 async function markAllAsRead() {
   if(notificationCount > 0){
  await axios.post(`${API_BASE_URL}/admin/updateNotificationCount`);
  setNotificationCount(0);
 }
 else{
  
 }

}






const menutwo = (
  
  <Menu >
    <Menu.Item key={0} >
        <h3>Notifications</h3>
      </Menu.Item>
    {list.map ((item) => (
      <Menu.Item key={item._id}>
        <Link to={`/admin/admin-panel/notification/${item._id}`}  >{item.content} </Link>
      </Menu.Item>
    ))}
    

      
  </Menu>
 
);
 

 
  return (
    <Header
      className="site-layout-background"
      style={{ background: "none" , placement:"bottomRight", marginBottom: "20px"}}
      
    >
      <div className="d-flex justify-content-end mt-2 login-header">
      <Dropdown onClick={markAllAsRead} overlay={menutwo} trigger={['click']}  placement="bottomRight" arrow>
<Badge count={notificationCount} overflowCount={10}>
 <Avatar style={{width: "50px", height: "50px", "line-height": "40px", "font-size": "30px"}} size={50} icon={<BellOutlined />} />
</Badge>
</Dropdown>
      <Dropdown overlay={menu} placement="bottomRight" arrow>
        <Avatar style={{width: "50px", height: "50px", "line-height": "40px", "font-size": "30px"}} size={50} className="me-0" icon={<UserOutlined />} />
      </Dropdown>
     
      </div>
    </Header>
  );
}
